import React, { useMemo } from 'react'

import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { getImages, findReplyByQuestionName } from '../../_helpers/pdfHelpers'

const CorrectiveActionsSection = ({ serviceOrder }) => {
  const images = useMemo(() => {
    return getImages(
      findReplyByQuestionName(
        serviceOrder.replies,
        'Foto da folha de ações corretivas imediatas devidamente assinada e carimbada pelo TST e Gerente da Agência. TIRAR FOTO LEGIVEL DA FOLHA COMPLETA.'
      )
    )
  }, [serviceOrder.replies])

  return (
    <View pageBreakAfter>
      <Separator weight={15} />

      {images.length ? (
        images.map((image, index) => (
          <Image style={{ margin: 'auto' }} maxHeight={850} key={index} src={image.src} ignoreFixedSize />
        ))
      ) : (
        <Text align={'center'}>Não encontrado</Text>
      )}
    </View>
  )
}

export default CorrectiveActionsSection
